import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import FIcon from '../../components/text/FIcon';
import LabelViewHorizontal from '../../components/LabelViewHorizontal';
import ListPedidosDeAgendamento from './ListPedidosDeAgendamento';
import * as Icons from '@material-ui/icons';
import { toast } from 'react-toastify';
import Axios from 'axios';
import { API_HOST } from '../../consts';
import {
  HorizontalLine,
  OpenButton,
  DivComposicao,
  StyledDiv,
  OuterContainer,
  InnerContainer,
  CardContainer,
  DivStatus
} from './styles/CardTemaStyles';
import DeleteModal from './DeleteModal';

export default function CardTema({
  redacaoTema,
  history,
  user,
  setUpdateTema,
  updateTema,
  requestStatus
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openComposicao, setOpenComposicao] = useState(false);
  const [idTema, setIdTema] = useState(false);
  const open = Boolean(anchorEl);
  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleDuplicateTema = async (id) => {
    try {
      const response = await Axios.post(
        `${API_HOST}/redacao_temas/temas/${id}/duplicate`
      );
      toast.success('Tema copiado com sucesso.');
      history.push(`/redacao/review/${response.data.id}`);
    } catch (error) {
      toast.error('Ocorreu um erro durante a cópia do Tema');
      console.error(error);
    }
  };

  useEffect(() => {
    setOpenComposicao(false);
  }, [requestStatus]);

  const handleInativarTema = async (id) => {
    try {
      const params = {
        status: 3
      };
      await Axios.put(`${API_HOST}/redacao_temas/temas/${id}`, params);
      toast.success('Tema inativado com sucesso.');
      setUpdateTema(!updateTema);
    } catch (error) {
      toast.error('Ocorreu um erro durante a inativação do Tema');
      console.error(error);
    }
    setIdTema();
  };

  const handleEditTema = async (redacaoTema) => {
    if (
      redacaoTema.criado_por.id === user.id ||
      user.logged_group.includes('ADMINISTRADOR')
    ) {
      try {
        history.push(`/redacao/edit/${redacaoTema.id}`);
      } catch (error) {
        toast.error(
          'Ocorreu um erro durante o redirecionamento para pagina de edicao'
        );
        console.error(error);
      }
    } else {
      toast.error('Você não tem permissão para editar esse tema');
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 4:
        return { cor: '#FFC107', bgcor: '#fdf4d9', descricao: 'Em análise' };
      case 3:
        return { cor: '#F44336', bgcor: '#e8c4c2', descricao: 'Inativo' };
      case 2:
        return { cor: '#4CAF50', bgcor: '#bddbbe', descricao: 'Aplicado' };
      default:
        return { cor: '#2189E8', bgcor: '#CBE4FF', descricao: 'Novo' };
    }
  };

  const handleIdTema = (id) => {
    setIdTema(id);
  };

  return (
    <div className="item-redacao container" key={`tema-${redacaoTema.id}`}>
      <CardContainer className="container">
        <DivStatus
          cor={getStatusColor(redacaoTema.status).cor}
          bgcor={getStatusColor(redacaoTema.status).bgcor}
        >
          {getStatusColor(redacaoTema.status).descricao}
        </DivStatus>
        <div className="row" style={{ flexWrap: 'nowrap' }}>
          <div style={{ width: '170%' }}>
            <div className="list-data">
              <div className="list-data-title">
                <h3
                  style={{ color: '#453166' }}
                >{`${redacaoTema.nome} #${redacaoTema.id} | ${redacaoTema.genero.nome} | ${redacaoTema.periodo.descricao}`}</h3>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div style={{ display: 'flex' }}>
                    <LabelViewHorizontal
                      key={'item-item'}
                      title={'Elaborador:'}
                      text={redacaoTema.criado_por.last_name}
                    />
                    <p className="meta-descip mt-2">
                      <FIcon icon="clock" type="far" />
                      <span className="mr-2 font-weight-normal">
                        Criado em: {redacaoTema.criado_em}
                      </span>
                    </p>
                  </div>
                  {redacaoTema.atualizado_em !== redacaoTema.criado_em && (
                    <div style={{ display: 'flex' }}>
                      <p className="meta-descip mt-0">
                        <span className="mr-2 font-weight-small">
                          Última atualização: {redacaoTema.atualizado_em}
                        </span>
                        <span className="mr-2 font-weight-small">
                          Atualizado por: {redacaoTema.atualizado_por}
                        </span>
                      </p>
                    </div>
                  )}
                </div>
                <div className="text-left"></div>
              </div>
            </div>
          </div>

          {redacaoTema.status !== 3 && (
            <OuterContainer>
              <InnerContainer>
                <IconButton
                  aria-label="more"
                  aria-controls="long-menu"
                  aria-haspopup="true"
                  onClick={(e) => handleClickMenu(e)}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  className="menu-atividade"
                  id="long-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={open}
                  onClose={() => handleCloseMenu()}
                  PaperProps={{
                    style: {
                      maxHeight: 'fit-content',
                      width: 'fit-content'
                    }
                  }}
                >
                  <MenuItem>
                    <Link
                      key={1}
                      to={`/redacao/revisao-aplicacao/${redacaoTema.id}`}
                    >
                      Solicitar agendamento
                    </Link>
                  </MenuItem>
                  <MenuItem>
                    <Link
                      key={1}
                      to={`/redacao/criacao-projeto/${redacaoTema.id}`}
                    >
                      Criar projeto
                    </Link>
                  </MenuItem>
                  <MenuItem onClick={() => handleEditTema(redacaoTema)}>
                    Editar
                  </MenuItem>
                  <MenuItem onClick={() => handleDuplicateTema(redacaoTema.id)}>
                    Criar cópia do tema
                  </MenuItem>
                  {user.logged_group.includes('ADMINISTRADOR') && (
                    <MenuItem onClick={() => handleIdTema(redacaoTema.id)}>
                      Inativar tema
                    </MenuItem>
                  )}
                </Menu>
              </InnerContainer>
              <StyledDiv />
            </OuterContainer>
          )}
        </div>
        <HorizontalLine />
        <DivComposicao>
          <h3>Composição</h3>
          <OpenButton onClick={() => setOpenComposicao(!openComposicao)}>
            {openComposicao ? (
              <Icons.ExpandLess className="icon" />
            ) : (
              <Icons.ExpandMore className="icon" />
            )}
          </OpenButton>
        </DivComposicao>
        {openComposicao && (
          <ListPedidosDeAgendamento
            redacaoTema={redacaoTema}
            user={user}
            setUpdateTema={setUpdateTema}
            updateTema={updateTema}
            requestStatus={requestStatus}
          />
        )}
      </CardContainer>
      {idTema && (
        <DeleteModal
          handleInativarTema={handleInativarTema}
          setIdTema={setIdTema}
          idTema={idTema}
        />
      )}
    </div>
  );
}
